import { useState } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { FieldError } from "../../components/common/States";
import { useAuth, homeFor } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import { AuthCard } from "./Login";

export const Field = ({ id, label, error, ...props }) => (
  <div>
    <Label htmlFor={id}>{label}</Label>
    <Input id={id} className="mt-1.5" data-testid={`${id}-input`} {...props} />
    <FieldError>{error}</FieldError>
  </div>
);

export function validateAccount(f) {
  const e = {};
  if (f.name.trim().length < 2) e.name = "Nom requis (2 caractères min.)";
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email)) e.email = "Email invalide";
  if (f.password.length < 8) e.password = "8 caractères minimum";
  if (f.password !== f.confirm) e.confirm = "Les mots de passe ne correspondent pas";
  return e;
}

export default function Register() {
  const { user, authenticate } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [f, setF] = useState({ name: "", email: "", password: "", confirm: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  if (user) return <Navigate to={homeFor(user)} replace />;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (ev) => {
    ev.preventDefault();
    const e = validateAccount(f);
    setErrors(e);
    if (Object.keys(e).length) return;
    setLoading(true);
    try {
      const u = await authenticate("/auth/register", { name: f.name, email: f.email, password: f.password });
      navigate(params.get("next") || homeFor(u), { replace: true });
    } catch (err) { setErrors({ form: formatApiError(err) }); } finally { setLoading(false); }
  };

  return (
    <AuthCard title="Créer un compte usager" subtitle="Retrouvez tous vos avis et réclamations au même endroit."
      footer={<>Déjà inscrit ? <Link to="/connexion" className="font-medium text-blue-600" data-testid="register-login-link">Se connecter</Link></>}>
      <form onSubmit={submit} className="space-y-4" noValidate>
        <Field id="register-name" label="Nom complet" value={f.name} onChange={set("name")} error={errors.name} />
        <Field id="register-email" label="Email" type="email" value={f.email} onChange={set("email")} error={errors.email} />
        <Field id="register-password" label="Mot de passe" type="password" value={f.password} onChange={set("password")} error={errors.password} />
        <Field id="register-password-confirm" label="Confirmer le mot de passe" type="password" value={f.confirm} onChange={set("confirm")} error={errors.confirm} />
        <FieldError>{errors.form && <span data-testid="register-error">{errors.form}</span>}</FieldError>
        <Button type="submit" className="h-11 w-full rounded-full" disabled={loading} data-testid="register-submit-button">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Créer mon compte
        </Button>
      </form>
    </AuthCard>
  );
}
